import type { OpenapiClientPump } from 'src/openapi/pump';

export const poolFetchOrders: {
  value: OpenapiClientPump.GetPoolsQuery['sort'];
  name: string;
}[] = [
  { value: 'latest_trade_at', name: 'Featured 🔥' },
  { value: 'created_at', name: 'Creation Time' },
  { value: 'volume', name: 'Trading Volume' },
  { value: 'market_cap', name: 'Market Cap' },
];
